function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Alert, Spin, Button, Select, Space, Divider, Breadcrumb } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;

var EditUser = function EditUser(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? null : _ref$user,
      handleUpdate = _ref.handleUpdate;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormPrecessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      compsOptions = _useState8[0],
      setCompsOptions = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      insOptions = _useState10[0],
      setInsOptions = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      isDataLoading = _useState12[0],
      setIsDataLoading = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      companyId = _useState14[0],
      setCompanyId = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      insId = _useState16[0],
      setInsId = _useState16[1];

  var _useState17 = useState(true),
      _useState18 = _slicedToArray(_useState17, 2),
      companyOptionDisabled = _useState18[0],
      setCompanyOptionDisabled = _useState18[1];

  var _useState19 = useState(true),
      _useState20 = _slicedToArray(_useState19, 2),
      insOptionDisabled = _useState20[0],
      setInsOptionDisabled = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      depList = _useState22[0],
      setDepList = _useState22[1];

  var onRoleOptionChange = function onRoleOptionChange(v) {
    if (v == 12) {
      setCompanyOptionDisabled(false);
      setInsOptionDisabled(true);
    }

    if (v == 13) {
      setCompanyOptionDisabled(true);
      setInsOptionDisabled(false);
    }
  };

  var onCompanyOptionChange = function onCompanyOptionChange(v) {
    setCompanyId(v);
  };

  var onInsOptionChange = function onInsOptionChange(v) {
    setInsId(v);
  };

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append("department_id", values.department_id);
    formData.append('role', values.role);
    formData.append("id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'edituser', formData).then(function (response) {
      setIsFormProcessing(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handleUpdate();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    setIsDataLoading(true);
    axios.all([axios.get(Common.baseApiUrl + 'getcompanylist/' + Common.currentUser.id), axios.get(Common.baseApiUrl + "geticompanylist/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getdepartments"))]).then(function (response) {
      if (response[0].data.status == 200) {
        response[0].data.companyList.forEach(function (element) {
          setCompsOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: element.label,
              value: element.id
            }]);
          });
        });
        form.setFieldsValue({
          company_id: compsOptions
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }

      if (response[1].data.status == 200) {
        response[1].data.iclist.forEach(function (element) {
          setInsOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: element.label,
              value: element.id
            }]);
          });
        });
        form.setFieldsValue({
          insurance_company_id: compsOptions
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }

      if (response[2].data.status == 200) {
        response[2].data.departments.forEach(function (d) {
          setDepList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
        if (response[2].data.departments.length > 0) form.setFieldsValue({
          department_id: response[2].data.departments[0].id
        });
      }
    })["catch"](function (error) {});
    form.setFieldsValue({
      role: user.role,
      department_id: user.department_id,
      firstname: user.firstname,
      lastname: user.lastname,
      mobile: user.mobile,
      company_id: user.company_id
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: errorMessage,
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: successMessage,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "role",
            label: "Role",
            children: /*#__PURE__*/_jsxs(Select, {
              onChange: onRoleOptionChange,
              defaultValue: 1,
              children: [/*#__PURE__*/_jsx(Option, {
                value: 11,
                children: "Accueil"
              }), /*#__PURE__*/_jsx(Option, {
                value: 21,
                children: "Technicien Imagerie"
              }), /*#__PURE__*/_jsx(Option, {
                value: 31,
                children: "Consultation Neurologie"
              }), /*#__PURE__*/_jsx(Option, {
                value: 41,
                children: "Rodiologue interprete"
              }), /*#__PURE__*/_jsx(Option, {
                value: 51,
                children: "Comptable"
              }), /*#__PURE__*/_jsx(Option, {
                value: 71,
                children: "Laboratoire"
              }), /*#__PURE__*/_jsx(Option, {
                value: 91,
                children: "Super Administrateur"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "D\xE9partment",
            children: /*#__PURE__*/_jsx(Select, {
              options: depList
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            disabled: depList.length == 0,
            loading: isFormPrecessing,
            htmlType: "submit",
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "SAUVEGARDER"
            })
          })
        })
      })]
    })]
  });
};

export default EditUser;